export enum ROLE_V2_QUERIES_ENUM {
  GET_BY_ID = 'GET_BY_ID',
  GET_BY_MERCHANT_ID = 'GET_BY_MERCHANT_ID',
}
